/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Dashboard from '../../components/dashboard/Dashboard';
import { getDashboardURLS, setCurrentDashboard } from '../../actions/dashboard/Dashboard';
import { identityRegion, dashboardRegion, defaultDashboardName } from '../../constants/Constants';
import { getAccessToken, getIdToken, searchData } from '../../utility/common';

// eslint-disable-next-line react/jsx-filename-extension
const DashboardContainer = (props) => {
  const [value, setValue] = useState(null);
  const [isSearchError, setSearchError] = useState(null);

  const dashboardData = useSelector((state) => state.getDashboardList);

  const {
    dashboardListData, isDLSending, dLError, isDLSuccess,
  } = dashboardData;
  let defaultDashboard = [];
  if (dashboardListData !== null && Array.isArray(dashboardListData) && dashboardListData.length > 0) {
    const data = searchData(dashboardListData);
    const peopleDataReportObject = _.filter(data, (elem) => elem.Name === defaultDashboardName);
    if (peopleDataReportObject && peopleDataReportObject.length > 0) {
      defaultDashboard = peopleDataReportObject[0];
    } else {
      let dashboardName = '';
      let desc = '';
      let dashboarId = '';
      if (data.length > 0) {
        const { Name, description, DashboardId } = data[0];
        dashboardName = Name;
        desc = description || '';
        dashboarId = DashboardId;
      }
      const defaultDashboardObject = {
        Name: dashboardName,
        DashboardId: dashboarId,
        description: desc,
        children: [],
      };
      defaultDashboard = defaultDashboardObject;
    }
  }

  useEffect(() => {
    const data = searchData(dashboardListData);
    if (data.length > 0) {
      props.setCurrentDashboard({ currentDashboard: defaultDashboard });
      const dashboardURLParams = {
        identityRegion,
        dashboardRegion,
        openIdToken: getIdToken(),
        accessToken: getAccessToken(),
        resetDisabled: false,
        undoRedoDisabled: false,
        printEnabled: true,
        dashboardId: defaultDashboard.DashboardId,
      };
      props.getDashboardURLS(dashboardURLParams);
    }
  }, [isDLSuccess]);
  const dashboardUrl = useSelector((state) => state.getDashboardURLs);
  const { dasboardURLsData, isDURLsSending, uRLsError } = dashboardUrl;
  // eslint-disable-next-line consistent-return
  const handleSearch = (event, searchValue) => {
    setSearchError(false);
    setValue(searchValue);
    let currentDashboard = defaultDashboard;
    const dashboardURLParams = {
      identityRegion,
      dashboardRegion,
      openIdToken: getIdToken(),
      accessToken: getAccessToken(),
      resetDisabled: false,
      undoRedoDisabled: false,
      printEnabled: true,
      dashboardId: currentDashboard.DashboardId,
    };
    if (searchValue) {
      const searchReport = _.filter(searchData(dashboardListData), (elem) => elem.Name === searchValue.Name);
      if (!searchReport || searchReport.length <= 0) {
        setSearchError(true);
        return false;
      }
      currentDashboard = searchValue;
      dashboardURLParams.dashboardId = searchValue.DashboardId;
    }
    props.setCurrentDashboard({ currentDashboard });
    props.getDashboardURLS(dashboardURLParams);
  };
  const getSearchOptionsData = () => {
    let option = null;
    if (dashboardListData && Array.isArray(dashboardListData) && dashboardListData.length > 0) {
      option = searchData(dashboardListData);
    }
    return option;
  };

  const getCurrentDashboard = useSelector((state) => state.getCurrentDashboard);
  const { currentDashboard } = getCurrentDashboard;
  const { Name, description } = currentDashboard;
  return (
    <Dashboard
      {...props}
      dashboardUrl={dasboardURLsData}
      isDLSending={isDLSending}
      dLError={dLError}
      isDURLsSending={isDURLsSending}
      uRLsError={uRLsError}
      dashboardListData={getSearchOptionsData()}
      handleSearch={(event, searchValue) => handleSearch(event, searchValue)}
      searchValue={value}
      isSearchError={isSearchError}
      reportName={Name}
      reportDesc={description}
      isDLSuccess={isDLSuccess}
    />
  );
};

DashboardContainer.propTypes = {
  setCurrentDashboard: PropTypes.func.isRequired,
  getDashboardURLS: PropTypes.func.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const mapDispatchedToProps = {
  getDashboardURLS, setCurrentDashboard,
};

export default connect(null, mapDispatchedToProps)(DashboardContainer);
